import { Component } from '@angular/core';
import { InvoiceData, InvoiceService, OrderItem } from '../modules/shared/services/invoice.service';


@Component({
  selector: 'app-invoice-demo',
  standalone: true,
  imports: [],
  template: `
    <div class="container mt-4">
      <h2>Invoice Generator Demo</h2>
      <button class="btn btn-primary" (click)="generateSampleInvoice()">Generate Sample Invoice</button>
    </div>
  `,
  styles: []
})
export class InvoiceDemoComponent {
  constructor(private invoiceService: InvoiceService) {}

  generateSampleInvoice(): void {
    const sampleItems: OrderItem[] = [
      {
        description: 'Product A',
        quantity: 2,
        unitPrice: 29.99,
        total: 59.98
      },
      {
        description: 'Product B',
        quantity: 1,
        unitPrice: 49.99,
        total: 49.99
      },
      {
        description: 'Product C',
        quantity: 3,
        unitPrice: 19.99,
        total: 59.97
      }
    ];

    const subtotal = sampleItems.reduce((sum, item) => sum + item.total, 0);
    const tax = subtotal * 0.1; // 10% tax
    const total = subtotal + tax;

    const invoiceData: InvoiceData = {
      invoiceNumber: 'INV-2024-001',
      date: new Date(),
      customerName: 'John Doe',
      customerAddress: '456 Customer Street\nCity, State 54321',
      items: sampleItems,
      subtotal: subtotal,
      tax: tax,
      total: total
    };

    this.invoiceService.generateInvoice(invoiceData);
  }
}